import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { useTranslation } from 'react-i18next';
import TextAreaField from 'components/TextAreaField';
import validations from 'validations';
import { Modal, Button } from 'ncoded-component-library';
import { Form, Field } from 'react-final-form';

import './SendingInvoiceToEd.styles.scss';

type SendingInvoiceToEdForm = {
  reasonForNotGeneratingInvoice: string;
};

type SendingInvoiceToEdProps = {
  className?: string;
  onSuccess?: (values: SendingInvoiceToEdForm) => void;
};

const SendingInvoiceToEd: React.ForwardRefRenderFunction<
  ModalRef,
  SendingInvoiceToEdProps
> = (props, ref) => {
  const { className, onSuccess } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const { t } = useTranslation();

  const classes = classNames('sending-invoice-to-ed', className);

  const onSubmit = useCallback(
    (values: SendingInvoiceToEdForm) => {
      onSuccess(values);
      modal.close();
    },
    [modal, onSuccess],
  );

  return (
    <Modal ref={modalRef} className={classes} title={t('sendingInvoiceToEd')}>
      {modal?.openState && (
        <Form onSubmit={onSubmit}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <p>{t('sendingInvoiceToEdDescription')}</p>

              <Field
                name="reasonForNotGeneratingInvoice"
                label={t('reason')}
                component={TextAreaField}
                validate={validations.required()}
                maxLength={1000}
                required
                rows={4}
              />

              <div className="actions">
                <Button variant="link" onClick={modal.close}>
                  {t('back')}
                </Button>
                <Button type="submit">{t('sendToEd')}</Button>
              </div>
            </form>
          )}
        </Form>
      )}
    </Modal>
  );
};

export default forwardRef(SendingInvoiceToEd);
